<template>
  <div>
    <Breadtabsheader/>
    <div class="h-content w-content">
      <!--查询表单-->
      <div class="h-piece">
        <div class="h-formBox">
          <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder" ref="form">
            <div class="h-thirdColumn w-newColumn">
              <el-form-item label="经销商编码/名称" prop="agentCode">
                <el-input v-model="q.agentCode" placeholder="请输入经销商编码或名称"></el-input>
              </el-form-item>

              <el-form-item label="区域" prop="area">
                <brselect category="YLRegion" :v="q.areaCode" v-model="q.areaCode" :multiple="true"
                          :clearable="true"/>
              </el-form-item>
              <el-form-item label="经销商类型" prop="agentNameLike">
                <brselect category="fl_agent_type" :v="q.agentType" v-model="q.agentType" :clearable="true"/>
              </el-form-item>
            </div>

            <div class="l-screenBox">
              <div class="l-screen" @click="collapseChange">
                <img :src="isScreen?closeScreen:drawScreen" alt="">
                <div class="l-screenText">{{ isScreen ? "收起" : "展开" }}</div>
              </div>
              <div class="l-retrieval">
                <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                <el-button class="h-btn h-formBtn h-bgwhite" @click="reset">重置</el-button>
              </div>
            </div>
          </el-form>
        </div>
      </div>
      <!--展示表格-->
      <div class="h-table h-mrt30">
        <el-table :model="q"
                  ref="q"
                  :data="tableData"
                  stripe
                  style="width: 100%"
                  :border="true"
                  max-height="530"
        >
          <el-table-column
              prop="area"
              :show-overflow-tooltip="true"
              label="区域"
              width="80"
              fixed
          >
          </el-table-column>
          <el-table-column
              prop="agentType"
              :show-overflow-tooltip="true"
              label="经销商类型"
              width="80"
          >
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{scope.row.agentType|dictname('fl_agent_type')}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="agentCode"
              :show-overflow-tooltip="true"
              label="经销商编码"
              width="110"
              fixed
          >
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{ scope.row.agentCode }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="agentName"
              :show-overflow-tooltip="true"
              label="经销商名称"
              min-width="180"
              fixed
          >
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{ scope.row.agentName }}
              </div>
            </template>
          </el-table-column>

          <el-table-column label="1月" :show-overflow-tooltip="true">
            <el-table-column
                prop="tongqi1"
                :show-overflow-tooltip="true"
                label="同期(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqi1).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="janM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.janM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="jan"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.jan).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="janL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">
                  {{ (Number(scope.row.janL).toFixed(2)) + '%' }}
                </div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="2月" :show-overflow-tooltip="true">
            <el-table-column
                prop="tongqi2"
                :show-overflow-tooltip="true"
                label="同期(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqi2).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="febM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.febM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="feb"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.feb).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="febL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.febL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="3月" :show-overflow-tooltip="true">
            <el-table-column
                prop="tongqi3"
                :show-overflow-tooltip="true"
                label="同期(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqi3).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="marM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.marM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="mar"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.mar).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="marL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.marL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="一季度" :show-overflow-tooltip="true">
            <el-table-column
                prop="firstQuarterT"
                :show-overflow-tooltip="true"
                label="同期(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.firstQuarterT).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="firstQuarterM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.firstQuarterM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="firstQuarter"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.firstQuarter).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="firstQuarterL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.firstQuarterL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="4月" :show-overflow-tooltip="true">
            <el-table-column
                prop="tongqi4"
                :show-overflow-tooltip="true"
                label="同期(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqi4).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="aprM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.aprM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="apr"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.apr).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="aprL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.aprL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="5月" :show-overflow-tooltip="true">
            <el-table-column
                prop="tongqi5"
                :show-overflow-tooltip="true"
                label="同期(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqi5).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="mayM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.mayM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="may"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.may).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="mayL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.mayL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>

          <el-table-column label="6月" :show-overflow-tooltip="true">
            <el-table-column
                prop="tongqi6"
                :show-overflow-tooltip="true"
                label="同期(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqi6).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="junM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.junM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="jun"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.jun).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="junL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.junL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="二季度" :show-overflow-tooltip="true">
            <el-table-column
                prop="secondQuarterT"
                :show-overflow-tooltip="true"
                label="同期(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.secondQuarterT).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="secondQuarterM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.secondQuarterM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="secondQuarter"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.secondQuarter).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="secondQuarterL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.secondQuarterL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="7月" :show-overflow-tooltip="true">
            <el-table-column
                prop="tongqi7"
                :show-overflow-tooltip="true"
                label="同期(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqi7).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="julM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.julM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="jul"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.jul).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="julL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.julL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>

          <el-table-column label="8月" :show-overflow-tooltip="true">
            <el-table-column
                prop="tongqi8"
                :show-overflow-tooltip="true"
                label="同期(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqi8).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="augM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.augM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="aug"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.aug).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="augL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.augL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>

          <el-table-column label="9月" :show-overflow-tooltip="true">
            <el-table-column
                prop="tongqi9"
                :show-overflow-tooltip="true"
                label="同期(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqi9).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="sepM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.sepM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="sep"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.sep).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="sepL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.sepL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="三季度" :show-overflow-tooltip="true">
            <el-table-column
                prop="thirdQuarterT"
                :show-overflow-tooltip="true"
                label="同期(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.thirdQuarterT).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="thirdQuarterM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.thirdQuarterM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="thirdQuarter"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.thirdQuarter).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="thirdQuarterL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.thirdQuarterL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="10月" :show-overflow-tooltip="true">
            <el-table-column
                prop="tongqi10"
                :show-overflow-tooltip="true"
                label="同期(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqi10).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="octM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.octM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="oct"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.oct).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="octL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.octL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>

          <el-table-column label="11月" :show-overflow-tooltip="true">
            <el-table-column
                prop="tongqi11"
                :show-overflow-tooltip="true"
                label="同期(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqi11).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="novM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.novM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="nov"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.nov).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="novL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.novL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>

          <el-table-column label="12月" :show-overflow-tooltip="true">
            <el-table-column
                prop="tongqi12"
                :show-overflow-tooltip="true"
                label="同期(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqi12).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="deceM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.deceM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="dece"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.dece).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="deceL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.deceL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="四季度" :show-overflow-tooltip="true">
            <el-table-column
                prop="fourthQuarterT"
                :show-overflow-tooltip="true"
                label="同期(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.fourthQuarterT).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="fourthQuarterM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.fourthQuarterM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="fourthQuarter"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.fourthQuarter).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="fourthQuarterL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.fourthQuarterL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="全年合计" :show-overflow-tooltip="true">
            <el-table-column
                prop="yearT"
                :show-overflow-tooltip="true"
                label="同期(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.yearT).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="yearM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.yearM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="yearS"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.yearS).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="yearL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.yearL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column
              prop="isUse"
              :show-overflow-tooltip="true"
              label="状态"
              width="80"
          >
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{ scope.row.isUse | dictname('fl_lvyue_quit_status')}}
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="h-tableB h-mrt30">
          <div class="h-tableBL">
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                       @click="exportExcel" v-auth="'khlybbXs_daochu'">批量导出
            </el-button>
          </div>
          <div class="h-pagination2">
            <pagination :page="q" @query="query"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ss from '../../../api/SystemService'
import updownfile from '../../../utils/updownfile'

export default {
  components: {},
  data() {
    return {
      // 展开折叠筛选
      isScreen: false,
      closeScreen: require("@/assets/images/pimg/closeallic.png"),
      drawScreen: require("@/assets/images/pimg/dobleArr.png"),
      q: {
        agentName: '',
        agentCode: '',
        channel: null,
        rebateChainGroup: null,
        year: 2024,
        type: '',
        areaCode: null,
        isUse:'',
        pageSize: 10,
        pageNo: 1,
        total: 0
      },
      //table列表
      tableData: [],
      countlist:'',
    }
  },
  created() {
    this.q = {
      agentName: '',
      agentCode: '',
      channel: null,
      rebateChainGroup: null,
      type: '',
      isUse:0,
      areaCode: null,
      pageSize: 10,
      pageNo: 1,
      total: 0
    };
    this.q.agentCode = this.$route.query.agentCode || ''
    this.handleFilter();
  },
  methods: {
    // 展开折叠
    collapseChange() {
      this.isScreen = !this.isScreen;
    },
    //检索
    handleFilter() {
      this.query();
      this.queryTotal();
    },
    //重置
    reset() {
      this.q = {
        agentType : '',
        agentName: '',
        agentCode: '',
        channel: null,
        rebateChainGroup: null,
        belongIndustry:null,
        type: '',
        isUse:0,
        areaCode: null,

        pageSize: 10,
        pageNo: 1,
        total: 0
      },
          this.handleFilter();
    },
    //查询table
    query() {
      ss.fanli.getLyhh2025Page(this.q).then(rd => {
        this.q.total = rd.total;
        this.tableData = rd.records;
      });
    },
    //批量导出
    exportExcel() {
      updownfile.down("/api/swyl/v1/fl/flQudaoSalesVolume/downloadExcelLvyueHh2025", this.q, "post");
    },
  }
}
</script>
<style lang="scss">
.el-table thead.is-group th {
  background-color: #57aefe;
}

.w-content .el-table__footer-wrapper .cell {
  text-align: right;
}

.w-content .el-table__fixed-footer-wrapper tbody td {
  background: #cce7ff;
}

.w-content .el-table__footer-wrapper tbody td {
  background: #cce7ff;
}

.el-table--scrollable-x .el-table__body-wrapper {
  z-index: 1;
}

.el-table__fixed, .el-table__fixed-right {
  box-shadow: none;
}

.el-table__fixed, .el-table__fixed-right {
  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    content: '';
    z-index: 100;
    box-shadow: 0 0 10px rgba(0, 0, 0, .12);
  }
}

.el-table__fixed-footer-wrapper tbody td {
  border-top: 0;
}
</style>